import { CustomReducedDto } from "@/types/api/api-types";

export const countriesOptions = (customs: CustomReducedDto[] | []) =>
  customs
    .map((custom) => ({
      label: custom.label,
      value: custom.id,
      countryCode: typeof custom.flagCode === "string" ? custom.flagCode : "",
    }))
    .sort((a, b) => {
      const countryA = a.label.toLowerCase();
      const countryB = b.label.toLowerCase();
      const priority = ["usa", "usa ddp", "usa dap", "royaume-uni"];

      const indexA = priority.indexOf(countryA);
      const indexB = priority.indexOf(countryB);

      if (indexA !== -1 && indexB === -1) return -1;
      if (indexA === -1 && indexB !== -1) return 1;
      if (indexA !== -1 && indexB !== -1) return indexA - indexB;

      return countryA.localeCompare(countryB);
    });
